import { Stack, styled, Text } from 'shell/components';

const SettingsSection = ({ id, title, titleAdornment, description, sectionGap = 6, children }) => (
    <SectionRoot id={`settings-section-${id}`} data-settings-section={id} $sectionGap={sectionGap}>
        <SectionHeader spacing={2}>
            <Stack alignItems='center' direction='row' spacing={titleAdornment ? 2 : 0}>
                <Text component='h2' variant='sh1' weight='semibold'>
                    {title}
                </Text>
                {titleAdornment}
            </Stack>
            {description && <Text color='light'>{description}</Text>}
        </SectionHeader>
        {children}
    </SectionRoot>
);

const SectionRoot = styled(Stack)(({ theme, $sectionGap }) => ({
    gap: theme.spacing($sectionGap),
    scrollMarginTop: theme.spacing(4),
}));

const SectionHeader = styled(Stack)(({ theme }) => ({
    gap: theme.spacing(2),
}));

export default SettingsSection;
